export const getPaginateData = (data, offset, limit) => {
  const filteredData = data.slice(offset, offset + limit);

  return {
    pagination: { offset, limit },
    data: filteredData
  };
};

export default getPaginateData;
